<template>
    <div class="separatorHeader">
    </div>

    <div class="bannerCarrera text-center mt-4">
        <div class="align-items-center">
            <h1 class="bannerTitle">XHIDENXHI Trail – 7Km</h1>
            <h4 class="bannerDate">Mar 1, 2026</h4>
        </div>

        <img src="@/assets/images/LogoBio.png" alt="Logo Banner" class="imgHome img-fluid mt-4">
    </div>

    <!-- Card Info -->
    <CardInfo :banner="bannerCarrera" />

    <!-- Seccion Principal -->
    <section class="full-center">
        <div class="center-content">
            <img class="imgBanner img-fluid" src="@/assets/images/logo_principal.png" alt="Logo Bioparque" />

            <h2 class="textBoldBodyCard mt-3">
                Vive la aventura en Bioparque Estrella
            </h2>

            <p class="textRegularBodyCard mt-3">
                Prepárate para una experiencia única en contacto con la naturaleza. Corre entre paisajes
                espectaculares, rodeado de fauna y atracciones que harán de esta carrera una jornada inolvidable.
            </p>
        </div>
    </section>

    <div class="container">
        <div class="card mb-5 card-principal">
            <div class="card-header card-principal-header text-center">
                <h4 class="mt-2">INFORMACIÓN DE LA CARRERA</h4>
            </div>

            <div>
                <!-- Información de la carrera -->
                <div class="banner-info-carrera text-center" id="informacion">
                    <div class="row">
                        <div class="col-lg-6 col-md-6">
                            <span>Fecha: Domingo 1 de marzo de 2026</span>
                        </div>

                        <div class="col-lg-6 col-md-6" >
                            <span>Sede: Bioparque Estrella Edo. Mex.</span>
                        </div>
                    </div>
                </div>

                <section class="mt-4"
                    style="padding-top: 0px; padding-left: 20px; padding-right: 20px; padding-bottom: 0px;">
                    <div class="container">
                        <div class="row">
                            <div class="col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <img src="@/assets/images/mapaBio.png" class="mapaBio" alt="Mapa Bioparque">
                            </div>

                            <div class="col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0 list-info-carrera">
                                <span><i class="bi bi-flag-fill me-2"></i> Salida: Entrada Bioparque Estrella</span>
                                <span><i class="bi bi-people-fill me-2"></i> Concentración: 6:00 AM</span>
                                <span><i class="bi bi-clock-fill me-2"></i> Salida puntual: 7:00 AM</span>
                                <span><i class="bi bi-flag-fill me-2"></i> Llegada: Entrada Bioparque Estrella</span>
                                <span><i class="fas fa-route me-2"></i> Distancia: 7 kilómetros</span>
                            </div>
                        </div>

                        <div class="text-center">
                            <button class="btn-llegar" @click="abrirMapa">
                                <i class="bi bi-geo-alt-fill"></i> Cómo llegar
                            </button>
                        </div>

                        <div class="categories-container text-center my-5">
                            <h3 class="mb-4">CATEGORÍAS</h3>

                            <div class="row justify-content-center">
                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                                    <h4>Libre</h4>
                                    <h5>hasta 35 años</h5>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                                    <h4>Master</h4>
                                    <h5>35 a 49 años</h5>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                                    <h4>Veteranos</h4>
                                    <h5>50 años en adelante</h5>
                                </div>
                                <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 ">
                                    <h4>Infantil</h4>
                                    <h5>Menores de 12 años</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <!-- Entrega de Kits -->
                <div class="header-kits text-center">
                    <h4>ENTREGA DE KITS</h4>
                </div>
                <section class="mt-4" style="padding-top: 0px; padding-left: 20px; padding-right: 20px;">
                    <div class="container my-5">
                        <div class="row g-4">

                            <!-- Card 28 FEB -->
                            <div class="col-md-6">
                                <div class="delivery-card">
                                    <div class="date-badge">
                                        <span class="day">28</span>
                                        <span class="month">FEB</span>
                                    </div>

                                    <div class="delivery-info" style="padding-left: 20px;">
                                        <div class="info-row">
                                            <i class="bi bi-clock-fill" style="padding-right: 6px;"></i>
                                            <span>10:00 am a 5:00 pm</span>
                                        </div>

                                        <div class="info-row-direccion">
                                            <i class="bi bi-geo-alt-fill" style="padding-right: 6px;"></i>
                                            <span>Avenida Andrés Molina Enríquez #215, a un costado del INE, La Gran Ciudad, Jilotepec, Edo. Mex.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Card 01 MAR -->
                            <div class="col-md-6">
                                <div class="delivery-card">
                                    <div class="date-badge">
                                        <span class="day">01</span>
                                        <span class="month">MAR</span>
                                    </div>

                                    <div class="delivery-info" style="padding-left: 20px;">
                                        <div class="info-row">
                                            <i class="bi bi-clock-fill" style="padding-right: 6px;"></i>
                                            <span>6:00 am a 7:00 am</span>
                                        </div>

                                        <div class="info-row">
                                            <i class="bi bi-geo-alt-fill" style="padding-right: 6px;"></i>
                                            <span>Bioparque Estrella, Edo. Mex.</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="nota-fases text-center">
                        <h4>Nota:</h4>
                        <h5>Recuerda: la entrega de kits finaliza a las 7:00 a.m. el día del evento.</h5>
                    </div>
                </section>

                <!-- Beneficios del Kit -->
                <div class="header-kits text-center">
                    <h4>KIT Y BENEFICIOS DENTRO DEL PARQUE</h4>
                </div>
                <section class="mt-4" style="padding-top: 0px; padding-left: 20px; padding-right: 20px;">
                    <div class="container my-5">
                        <div class="row g-4">

                            <!-- Columna izquierda -->
                            <div class="col-lg-6">
                                <div class="row g-4">
                                    <div class="col-12">
                                        <!-- Card: Kit del corredor -->
                                        <div class="delivery-card">
                                            <div class="date-badge">
                                                <i class="bi bi-backpack2-fill logoBackPack"></i>
                                            </div>

                                            <div class="delivery-info">
                                                <div class="info-row-beneficios">
                                                    <ul class="lista-kit lista-atracciones">
                                                        <li>1. Flyer de presentación</li>
                                                        <li>2. Número de corredor</li>
                                                        <li>3. Playera premium</li>
                                                        <li>4. Morral (para los primeros 700 inscritos)</li>
                                                        <li>5. Medalla</li>
                                                        <li>6. Dos pulseras</li>
                                                        <li>7. Hidratación y snacks postevento</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <!-- Card: Actividades NO incluidas -->
                                        <div class="delivery-card">
                                            <div class="date-badge-red">
                                                <i class="fa-solid fa-circle-xmark logoBackPack"></i>
                                            </div>

                                            <div class="bioparque-image-container">
                                                <img src="@/assets/images/LogoBio.png" alt="Precios Bioparque"
                                                    class="bioparque-image" />
                                            </div>

                                            <div class="delivery-info">
                                                <p class="text-kits"></p>
                                                <div class="info-row-beneficios">
                                                    <ul class="lista-ata lista-atracciones">
                                                        <li>Xcalibur – $60</li>
                                                        <li>Xtremus – $50</li>
                                                        <li>Toro mecanico – $50</li>
                                                        <li>Pared de escalar – $50</li>
                                                        <li>Aerobongi – $50</li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Columna derecha (card alta) -->
                            <div class="col-lg-6">
                                <!-- Card: Accesos incluidos -->
                                <div class="delivery-card">
                                    <div class="date-badge-green">
                                        <i class="fa-solid fa-circle-check logoBackPack"></i>
                                    </div>

                                    <div class="bioparque-image-container">
                                        <img src="@/assets/images/LogoBio.png" alt="Precios Bioparque"
                                            class="bioparque-image" />
                                    </div>

                                    <div class="delivery-info">
                                        <p class="text-kits"></p>
                                        <div class="info-row-beneficios">
                                            <ul class="lista-atracciones mt-2">
                                                <li>1. Río Jurásico</li>
                                                <li>2. Paraíso de Jirafas</li>
                                                <li>3. Safari Serengueti</li>
                                                <li>4. Tierra de Dinosaurios</li>
                                                <li>5. Espectáculo Bucaneros y Lobos de Mar</li>
                                                <li>6. Recorrido Subterráneo</li>
                                                <li>7. Museo</li>
                                                <li>8. Sala Visual</li>
                                                <li>9. Lago Ziwa (lanchas de pedales)</li>
                                                <li>10. Teatro Muziki</li>
                                                <li>11. Espectáculo de Aves</li>
                                                <li>12. Pabellón Ecológico</li>
                                                <li>13. Sala de Proyección</li>
                                                <li>14. Mini Zoo</li>
                                                <li>15. Area de Juegos</li>
                                                <li>16. Mini Kamba (tirolesa infantil)</li>
                                                <li>17. Sendero de Puentes Colgantes</li>
                                                <li>18. Tigres de Bengala</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                <!-- Fases de registro -->
                <div class="header-kits text-center">
                    <h4>FASES DE REGISTRO</h4>
                </div>
                <section class="mt-4" style="padding-top: 0px; padding-left: 20px; padding-right: 20px;">
                    <div class="container my-5">
                        <div class="row row-cols-1 row-cols-md-3 mb-4 mb-lg-0">
                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="card card-fase text-center">
                                    <div class="card-header card-fase-header">
                                        <h3>FASE 1</h3>
                                        <h4>1 al 31 de diciembre de 2025</h4>
                                    </div>

                                    <div class="card-body">
                                        <h4 class="textTitle mb-0">$420 MXM</h4>
                                        <h5 class="textSubtitle mt-0">Por persona</h5>

                                        <h4 class="textTitle mt-4">¿Qué incluye?</h4>
                                        <ul class="list-group" style="list-style-type: none;">
                                            <li class="textSubtitle">Kit de carrera</li>
                                            <li class="textSubtitle">Beneficios del parque</li>
                                            <li class="textSubtitle">Rifa de evento</li>
                                            <li class="textSubtitle mb-4">Combo pizza postevento</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="card card-fase text-center">
                                    <div class="card-header card-fase-header">
                                        <h3>FASE 2</h3>
                                        <h4>1 al 31 de enero de 2026</h4>
                                    </div>

                                    <div class="card-body">
                                        <h4 class="textTitle mb-0">$500 MXM</h4>
                                        <h5 class="textSubtitle mt-0">Por persona</h5>

                                        <h4 class="textTitle mt-4">¿Qué incluye?</h4>
                                        <ul class="list-group" style="list-style-type: none;">
                                            <li class="textSubtitle">Kit de carrera</li>
                                            <li class="textSubtitle">Beneficios del parque</li>
                                            <li class="textSubtitle mb-4">Rifa de evento</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="card card-fase text-center">
                                    <div class="card-header card-fase-header">
                                        <h3>FASE 3</h3>
                                        <h4>1 al 29 de febrero de 2026</h4>
                                    </div>

                                    <div class="card-body">
                                        <h4 class="textTitle mb-0">$550 MXM</h4>
                                        <h5 class="textSubtitle mt-0">Por persona</h5>

                                        <h4 class="textTitle mt-4">¿Qué incluye?</h4>
                                        <ul class="list-group" style="list-style-type: none;">
                                            <li class="textSubtitle">Kit de carrera</li>
                                            <li class="textSubtitle">Beneficios del parque</li>
                                            <li class="textSubtitle mb-4">Rifa de evento</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="nota-fases text-center">
                            <h4>Nota:</h4>
                            <h5>Para la categoría infantil, el registro de niños se mantiene al costo de la fase 1,
                                $420, durante todo el periodo de inscripciones.</h5>
                        </div>

                        <div class="badgeAcom text-center mt-4">
                            <h4>Precio por acompañante en cualquier fase: $360</h4>
                        </div>

                    </div>
                </section>

                <!-- Formas de inscripción -->
                <div class="header-kits text-center">
                    <h4>FORMAS DE INSCRIPCIÓN</h4>
                </div>
                <section class="mt-4" style="padding-top: 0px; padding-left: 20px; padding-right: 20px;">
                    <div class="container my-5">
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="forma-pago">
                                    <img src="@/assets/images/patrocinadores/logoLGC-full.png" class="logo-formaPago"
                                        alt="logo">

                                    <div class="forma-pago-body">
                                        <h3>La Gran Ciudad Jilotepec y Tepeji</h3>
                                        <h5>Lunes a sábado: 10:00 am a 07:00 pm</h5>
                                        <h5>Domingo: 10:00 am a 06:00 pm</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-4">
                                <div class="forma-pago">
                                    <img src="@/assets/images/patrocinadores/buba.jpg" class="logo-formaPago-1"
                                        alt="logo">

                                    <div class="forma-pago-body buba-horarios">
                                        <h3>Sucursales Bubbaffle</h3>
                                        <h5>Lunes a viernes: 11:00 am a 10:00 pm</h5>
                                        <h5>Sábado y domingo: 02:00 pm a 10:00 pm</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="forma-pago">
                                    <img src="@/assets/images/logo_principal.png" class="logo-formaPago-1" alt="logo">

                                    <div class="forma-pago-body">
                                        <h3>Gimnasio El Terreno</h3>
                                        <h5>Lunes a viernes: 5:00 pm a 8:00 pm</h5>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-4 mb-lg-0">
                                <div class="forma-pago">
                                    <h3 class="titulo-forma-pago">En Linea</h3>

                                    <div class="forma-pago-body enlinea">
                                        <h3>Transferencia electrónica:</h3>
                                        <h5>728969000028945078</h5>

                                        <h3 class="mt-2">Banco:</h3>
                                        <h5>STP / Spin por OXXO</h5>

                                        <h3 class="mt-2">Nombre:</h3>
                                        <h5>Gimnasio El Terreno</h5>

                                        <h5 class="mt-2">Envía tu comprobante al número:</h5>
                                        <h3>55408661907</h3>
                                        <h5 class="mt-1">Donde continuará tu proceso de registro</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </div>

    <!-- Patrocinadores -->
    <Partners />
</template>

<script setup>
import Partners from '@/components/Partners.vue'
import CardInfo from '@/components/CardInfo.vue'
import bannerCarrera from '@/assets/images/2026/banner2026.jpeg'

function abrirMapa () {
  window.open('https://maps.app.goo.gl/rYhGEBwSNzqfTfZw9')
}
</script>

<style scoped>
@font-face {
    font-family: 'Dangrek';
    src: url('@/assets/fonts/Dangrek-Regular.ttf') format('truetype');
    font-weight: normal;
}

@font-face {
    font-family: 'FjallaOne';
    src: url('@/assets/fonts/FjallaOne-Regular.ttf') format('truetype');
    font-weight: normal;
}

.lista-atracciones {
    list-style-type: none;
    margin: 0;
    padding: 0;
    padding-left: 15px;
}

.bannerHome {
    background: linear-gradient(90deg, #DEEEA8 0%, #1B1E20 40%);
    padding: 40px 24px;
}

.separatorHeader {
    background-color: #DD611F;
    width: 100%;
    height: 30px;
}

.bannerCarrera {
    background-color: #F6F1EC;
    padding: 30px;
}

.bannerTitle {
    font-family: 'Dangrek';
    color: #17775C;
    font-size: 3.5rem;
}

.bannerDate {
    font-family: 'Dangrek';
    color: #17775C;
    font-size: 1.5rem;
}

/* Card Principal */
.card-principal {
    border-radius: 50px;
    overflow: hidden;
}

.card-principal-header {
    font-family: 'FjallaOne';
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    background-color: #DD611F;
    color: #FFFFFF;
}

/* Sección Información */
.banner-info-carrera {
    background-color: #17775C;
    font-family: 'Dangrek';
    color: white;
    font-size: 1.1rem;
}

.list-info-carrera {
  font-family: 'Dangrek';
  color: #1B1E20;
}

.list-info-carrera span {
  display: block;
  margin-bottom: 18px;
  font-size: 1.1rem;
}

.mapaBio {
  border-bottom-left-radius: 20px;
  width: 100%;
  height: auto;
}

.btn-llegar {
  background-color: #DD611F;
  border-radius: 10px;
  font-family: 'Dangrek';
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1.2rem;
  margin-top: 20px;
}

.categories-container h3 {
  font-family: 'FjallaOne', sans-serif;
  font-weight: 700;
  letter-spacing: 2px;
}

.category-card {
  background-color: #f8f9fa;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
}

.category-card:hover {
  transform: translateY(-5px);
}

.categories-container .row div h4 {
    font-family: 'Dangrek';
    color: #17775C;
}

.title-category {
    font-family: 'Dangrek';
}

/* Estilos de texto Inicial */
.full-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.center-content {
  text-align: center;
  max-width: 720px;
  padding: 0 16px;
}

.imgBanner {
  display: block;
  margin: 0 auto;
  max-width: 180px;
}

/* Kits */
.header-kits {
    background-color: #DD611F;
    color: #FFFFFF;
    font-family: 'FjallaOne';
    padding-top: 10px;
    padding-bottom: 5px;
    padding-left: 0px;
    padding-right: 0px;
}

.delivery-card {
  position: relative;
  display: flex;
  align-items: stretch;
  background-color: #e0e0e0;
  border-radius: 6px;
  overflow: hidden;
  min-height: 100px;
}

.bioparque-image-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
}

.bioparque-image {
  width: 90px;
  height: auto;
  border-radius: 6px;
}

.date-badge {
  background-color: #2f6b53;
  color: #ffffff;
  padding: 5px;
  text-align: center;
  min-width: 50px;

  display: flex;
  flex-direction: column;
  justify-content: center;
}

.date-badge .day {
  font-size: 2rem;
  font-weight: 700;
  line-height: 1;
  margin: 0;
}

.date-badge .month {
  font-size: 1.6rem;
  font-weight: 600;
  margin: 0;
}

.date-badge-red {
  background-color: #B51E1E;
  color: #ffffff;
  padding-left: 5px;
  text-align: center;
  min-width: 50px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.date-badge-green {
  background-color: #2f6b53;
  color: #ffffff;
  padding-left: 5px;
  text-align: center;
  min-width: 50px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.delivery-info {
  padding: 16px 0px;
  flex: 1;
}

.info-row {
  align-items: start;
  gap: 12px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #000;
}

.info-row-direccion {
    display: flex;
    align-items: start;
    gap: 1px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #000;
}

.info-row-direccion i {
    flex-shrink: 0;
    margin-top: 2px;
}

.info-row-direccion span {
    line-height: 1;
}

.info-row-beneficios {
  align-items: start;
  gap: 12px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #000;
  font-size: 1.2rem;
}

.info-row i {
  font-size: 1.2rem;
}

.logoBackPack {
    font-size: 2rem;
}

.text-kits {
    font-family: 'Dangrek';
    margin-left: 10px;
}

.imgKit {
    height: 50px;
    filter: drop-shadow(0px 4px 12px rgba(0,0,0,0.4));
}

.lista-ata li {
    margin-bottom: 10px;
}

.lista-kit li {
    margin-bottom: 3px;
}

/* Fases de registro */
.card-fase {
    border-radius: 50px;
    overflow: hidden;
    background-color: #e0e0e0;
    border: none;
}

.card-fase-header {
    border-top-left-radius: 50px;
    border-top-right-radius: 50px;
    background-color: #2f6b53;
    color: #FFFFFF;
}

.card-fase-header h3 {
    font-family: 'FjallaOne';
}

.card-fase-header h4 {
    font-family: 'Dangrek';
    font-size: 15px;
}

.badgeAcom {
    background-color: #2f6b53;
    border-radius: 20px;
}

.badgeAcom h4 {
    font-family: 'Dangrek';
    color: white;
    font-size: 19px;
    padding-top: 4px;
    padding-bottom: 4px;
}

.nota-fases h4{
    font-family: 'Dangrek';
    color: #DD611F;
}

/* Formas de inscripción */
.forma-pago {
    background-color: white;
    padding: 20px;
    display: flex;
    align-items: stretch;
    border: 2px solid #DEEEA8;
    border-radius: 10px;
}

.logo-formaPago {
    height:90px;
}

.logo-formaPago-1 {
    height: 90px;
    border-radius: 90px;
}

.forma-pago-body {
    padding-left: 20px;
}

.forma-pago-body h3 {
    font-family: 'Dangrek';
    color: #1B1E20;
    font-size: 1.5rem;
}

.forma-pago-body h5 {
    color: #1B1E20;
    font-weight: 100;
}

.buba-horarios h5 {
    margin-top: 5px;
    margin-bottom: 0px;
}

.titulo-forma-pago {
    font-family: 'Dangrek';
    color: #1B1E20;
}

.enlinea h3 {
    font-family: 'Dangrek';
    margin-bottom: 0px;
    font-size: 20px;
}

.imgHome {
    height: 100px;
    filter: drop-shadow(0px 4px 12px rgba(0,0,0,0.4));
}

/* Responsive para móviles */
@media (max-width: 768px) {
    .title {
        font-size: 3rem;
        text-align: center;
    }

    .date {
        text-align: center;
    }

    .bannerHome {
        padding: 28px 16px;
        background: linear-gradient(180deg, #DEEEA8 0%, #1B1E20 90%);
    }
}

/* Estilo para el card Principal */
 .cardInfo {
  background-color: white;
  border: none;
  border-radius: 16px;
  padding: 24px 10px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
}

.logoCard {
  border-radius: 16px;
  height: 170px;
  width: 100%;
  max-width: 170px;
  object-fit: cover;
  margin: 0 auto 16px auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.textTitle {
  font-family: "Dangrek";
  font-size: 1.7rem;
  font-weight: bold;
  color: #1B1E20;
  padding-top: 12px;
}

.textSubtitle {
  font-family: "Dangrek";
  font-size: 15px;
  color: #1B1E20;
  margin-bottom: 8px;
  font-weight: 200;
}

.textRegularBodyCard {
  color: #1B1E20;
  opacity: 0.85;
}

.textBoldBodyCard {
    font-family: "GYMZain", sans-serif;
    font-size: 20px;
    font-weight: bold;
    margin: 0;
    color: #1B1E20;
  font-weight: 600;
}

/* Distancia */
.distance {
  background: #1B1E20;
  color: #F6F1EC;
  padding: 80px 16px;
  text-align: center;
}

.distance span {
  font-size: 6rem;
  font-weight: bold;
  color: #DEEEA8;
}
</style>
